import { Model } from './model';
import { BusStop } from './bus-stop.model';

export class Group extends Model {
  name: string;
  pickupPoints: [BusStop]
}
